(() => {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();
      this.isOpen = true;
      this.btn = this.querySelector("[data-accordion-btn]");
      this.content = this.querySelector("[data-accordion-content]");

      this.btn.addEventListener("click", this.toggle.bind(this));
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
      this.isOpen = !this.isOpen;
    }

    open() {
      this.btn.classList.remove("closed");
      this.content.classList.remove("d-none");
      const height = this.content.scrollHeight;

      this.content.animate([{ height: 0 }, { height }], { duration: 300 });
    }

    close() {
      this.btn.classList.add("closed");
      this.content.style.height = `${this.content.scrollHeight}px`;
      
      this.content.animate([{ height: this.content.scrollHeight }, { height: 0 }], { duration: 300 }).onfinish = () => {
        this.content.classList.add("d-none");
      };
    }
  }

  if (!customElements.get("accordion-item")) {
    customElements.define("accordion-item", AccordionItem);
  }
})();
